export const initialHomeMembersState = {
    membersById: {},
    memberIdsByHomeId: {},
};
